export default __webpack_public_path__ + "static/media/to_delete6.4901fbd6.png";